/* eslint-disable camelcase */
import Vue from 'vue';

import Dialog from './views/dialog.vue';
import Default from './views/default.vue';
import ResumeSel from './views/resumeSel.vue';
import VerifyPhone from './views/verifyPhone.vue';
import { handlerCapture } from './utils/tools';

import Toasted from 'vue-toasted';
Vue.use(Toasted, {
    // theme: 'bubble',
    position: 'bottom-center',
    duration: 3000
});

Vue.config.errorHandler = (err, vm, info) => {
    handlerCapture(err, info);
};

import { api } from './utils/api';

import './assets/css/index.scss';
// import './utils/flexible';
import './utils/lunaFlexible';

import { handlerDeliveryCheck } from './js/delivery';

import track from './utils/track';

Vue.prototype.$api = api;

Vue.prototype.$handlerCapture = handlerCapture;

Vue.config.productionTip = false;

class LunaResume {

    instance = null;

    constructor(options = {}) {

        const optsMap = { Dialog };

        const AppDefault = optsMap[options.type] || Default;

        const init = (App, data = options) => {
            this.instance = new Vue({
                data: () => ({ visible: true, ...data }),
                render(h) {
                    return this.visible ? h(App) : null;
                }
            });
            this.instance.$mount();
            document.body.appendChild(this.instance.$el);
            /**
             * 上报初始化埋点
             */
            track({
                d: {
                    page_type: options.type === 'Dialog' ? 1000 : 1001,
                    element_id: 80
                }
            });
        };

        if (options.state === 'edit' || !options.infoId) {
            init(AppDefault);
        } else {
            handlerDeliveryCheck(
                options,
                ({ type = '', ...args } = {}) => {
                    const typeMap = { ResumeSel, VerifyPhone };
                    const App = typeMap[type] || AppDefault;
                    init(App, { ...options, ...args });
                }
            );
        }
    }

    show() {
        this.instance.visible = true;
    }

    destroy() {
        if (this.instance) {
            document.body.removeChild(this.instance.$el);
            this.instance.$destroy();
            this.instance = null;
        }
    }
}

export { LunaResume };
